module.exports = Object.freeze({
  ACCEPTED: "accepted",
  DECLINED: "declined",
  CANCELED: "canceled",
  FAILED: "failed",
  NOT_ANSWERED: "not-answered",
  COMPLETED: "completed",
  RINGING: "ringing",
  IN_PROGRESS: "in-progress",
  // custom
  CALLING: "calling",
});
